import React, { useState, useRef } from 'react';
import ReactApexChart from 'react-apexcharts';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useSelector } from 'react-redux';

const AgeGroupChart = () => {
  const ageGroupFilter = useSelector(state => state.dashboard?.ageGroupCount) || {};
  const categories = ageGroupFilter?.categories || [];
  const seriesData = ageGroupFilter?.series || [];

  const [showModal, setShowModal] = useState(false);
  const chartRef = useRef(null);

  const options = {
    chart: {
      type: 'bar',
      height: 250,
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        distributed: true,
        borderRadius: 4,
        columnWidth: '20%',
        dataLabels: { position: 'top' }
      }
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => val + "%",
      offsetY: -10,
      style: { fontSize: '12px', colors: ["#000"] }
    },
    xaxis: {
      categories: categories,
      labels: { style: { fontSize: '12px' } },
      legend: { position: 'top' }
    },
    yaxis: {
      max: 60,
      labels: {
        formatter: (val) => val + "%",
        style: { fontSize: '12px' }
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'horizontal',
        shadeIntensity: 0.6,
        gradientToColors: ['#181818', '#141517', '#001510', '#061700'],
        inverseColors: false,
        opacityFrom: 0.9,
        opacityTo: 1,
        stops: [0, 100]
      }
    },
    colors: ['#BA8B02', '#6A9113', '#00bf8f', '#52c234'],
    grid: { borderColor: '' }
  };

  const series = [{
    name: 'Percentage',
    data: seriesData
  }];

  const exportPDF = async () => {
    if (!chartRef.current) return;

    const canvas = await html2canvas(chartRef.current, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("landscape", "pt", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 40, pdfWidth, pdfHeight);
    pdf.save("age-group-distribution.pdf");
  };

  return (
    <>
      <div className='bg-white rounded-lg shadow-md flex flex-col h-full'>
        <div className="border-b px-4 py-3 rounded-t-lg gradiant2">
          <h3 className="text-[0.875rem] tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Age Group Distribution
          </h3>
        </div>
        <div
          className="cursor-pointer"
          onClick={() => setShowModal(true)}
          title="Click to view fullscreen"
        >
          <ReactApexChart options={options} series={series} type="bar" />
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center">
          <button
            className="absolute top-4 left-6 text-3xl font-bold text-gray-600 hover:text-black"
            onClick={() => setShowModal(false)}
          >
            ×
          </button>

          <div className="absolute top-4 right-6">
            <div className="relative inline-block text-left">
              <div className="origin-top-right absolute right-0 gradiant2 mt-2 w-40 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                <div className="py-1">
                  <button
                    onClick={exportPDF}
                    className="w-full px-4 py-2 text-sm text-[#856800] font-bold"
                  >
                    Export PDF
                  </button>
                </div>
              </div>
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-4 text-[#856800] mt-8">
            Age Group Distribution
          </h2>

          <div ref={chartRef} className="w-[90vw] h-[80vh] flex items-center justify-center">
            <ReactApexChart
              options={options}
              series={series}
              type="bar"
              height={500}
              width={1000}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default AgeGroupChart;
